export const RequestTimeSettingStatus = {
    List: [
        {label: "VMS_REQUEST_TIME_SETTING_DISABLE", value: "00"},
        {label: "VMS_REQUEST_TIME_SETTING_ENABLE", value: "01"}
    ],
    Map: new Map<string, string>([
        ['00', 'VMS_REQUEST_TIME_SETTING_DISABLE'],
        ['01', 'VMS_REQUEST_TIME_SETTING_ENABLE'],
    ]),
    Enum: {
        Disable: '00',
        Enable: "01"
    }
};